import React, { useContext } from 'react';
import { usePortfolio } from '../Context/PortfolioContext'; // Adjust the path as needed
import ESGResultsVisualization from './ESGResultsVisualization';
import MonteCarloResultsVisualization from './MonteCarloResultsVisualization';
import MeanVarianceOptimization from '../OptimizationSettingDisplay/MeanVarianceOptimization';
import PortfolioMetricsCard from './PortfolioMetricsCard';
import BacktestedReturnsComponent from './BacktestComponent/BacktestComponent';
import YearlyPriceChart from './VisualizationComponent/YearlyPriceChart/YearlyPriceChart';
import OptimizationResultsPieChart from './VisualizationComponent/PiChart/PiChart';
const ResultsColumn = () => {

    const { portfolioData, updateOptimizationResults, updateOptimizationMethod } = usePortfolio();
    const { optimizationMethod, selectedAssets, covarianceMatrix, returnsArray, optimizationResults } = portfolioData;
    // Local state for method-specific parameters
    return (
        <>
        <PortfolioMetricsCard selectedAssets={selectedAssets} optimizationResults={optimizationResults} />
        <BacktestedReturnsComponent selectedAssets={selectedAssets} optimizationResults={optimizationResults} />
        <div>
            {optimizationMethod === 'Mean Variance Optimization' && (
                <>
                <MeanVarianceOptimization/>
                </>
            )
            }
            {optimizationMethod === 'ESG Mean Variance Optimization' && (
                <>
                <ESGResultsVisualization data={optimizationResults} />
                </>
            )}
            {optimizationMethod === 'Monte Carlo Simulation' && (
                <>
                <MonteCarloResultsVisualization data={optimizationResults} />
                </>
            )}
            {/* Add additional conditions and visualization components as needed */}
        </div>
        <div>
            <div className="graphs-container">
                <div className="graph-wrapper">
                    <h2 className="graph-title">Yearly Price Data</h2>
                    <p className="graph-description">This line chart displays the yearly price data from 2013 to 2023.</p>
                    <YearlyPriceChart selectedAssets={selectedAssets} />
                </div>
                <div className="graph-wrapper">
                    <h2 className="graph-title">Weight Optimization Results</h2>
                    <p className="graph-description">The pie chart visualizes the weight distribution of optimized assets.</p>
                    <OptimizationResultsPieChart />
                </div>
            </div>
        </div>
        </>
    );
};

export default ResultsColumn;